<template>
    <div v-if="stage" class="px-4">
        <v-row>
            <v-col>
                <v-card-text class="ml-0 pa-0 ma-0">
                    <label> Fecha: </label>
                </v-card-text>
                <RouteInBagSelectorComponent
                    v-model="stage.accounting_date"
                    :my_bag="my_bag"
                    outlined
                    hide-details="auto"
                    :error="showErrors && !stage.accounting_date"
                    @change="computeStage">
                </RouteInBagSelectorComponent>
            </v-col>
            <v-col>
                <v-card-text class="ml-0 pa-0 ma-0">
                    <label> Identificador externo empleado: </label>
                </v-card-text>
                <RouteInBagSelectorComponent
                    v-model="stage.worker_id"
                    :my_bag="my_bag"
                    outlined
                    hide-details="auto"
                    :error="showErrors && !stage.worker_id"
                    @change="computeStage">
                </RouteInBagSelectorComponent>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-text-field
                    v-model="stage.description"
                    label="Descripción"
                    outlined
                    hide-details="auto"
                    :error="showErrors && !stage.description"
                    :background-color="showErrors && !stage.description ? '#DC0B0B1A' : 'white'"
                    @change="computeStage">
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card-text class="ml-0 pa-0 ma-0">
                    <label> Salario bruto: </label>
                </v-card-text>
                <RouteInBagSelectorComponent
                    v-model="stage.salary"
                    :my_bag="my_bag"
                    outlined
                    hide-details="auto"
                    :error="showErrors && !stage.salary"
                    @change="computeStage">
                </RouteInBagSelectorComponent>
            </v-col>
            <v-col>
                <v-card-text class="ml-0 pa-0 ma-0">
                    <label> Cuenta salario bruto: </label>
                </v-card-text>
                <RouteInBagSelectorComponent
                    v-model="stage.salary_account"
                    :my_bag="my_bag"
                    outlined
                    hide-details="auto"
                    :error="showErrors && !stage.salary_account"
                    @change="computeStage">
                </RouteInBagSelectorComponent>
            </v-col>
        </v-row>
        <v-row>
            <!-- <v-col>
                <v-card-text class="ml-0 pa-0 ma-0">
                    <label> Total seguridad social: </label>
                </v-card-text>
                <RouteInBagSelectorComponent
                    v-model="stage.total_social_security"
                    :my_bag="my_bag"
                    outlined
                    hide-details="auto"
                    :error="showErrors && !stage.total_social_security"
                    @change="computeStage">
                </RouteInBagSelectorComponent>
            </v-col> -->
            <v-col>
                <v-card-text class="ml-0 pa-0 ma-0">
                    <label> Cuenta deudas seguridad social: </label>
                </v-card-text>
                <RouteInBagSelectorComponent
                    v-model="stage.total_social_security_account"
                    :my_bag="my_bag"
                    outlined
                    hide-details="auto"
                    :error="showErrors && !stage.total_social_security_account"
                    @change="computeStage">
                </RouteInBagSelectorComponent>
            </v-col>
        </v-row>
        <v-row>
            <!-- <v-col>
                <v-card-text class="ml-0 pa-0 ma-0">
                    <label> Total gastos SS empresa: </label>
                </v-card-text>
                <RouteInBagSelectorComponent
                    v-model="stage.social_security_expense"
                    :my_bag="my_bag"
                    outlined
                    hide-details="auto"
                    :error="showErrors && !stage.social_security_expense"
                    @change="computeStage">
                </RouteInBagSelectorComponent>
            </v-col> -->
            <v-col>
                <v-card-text class="ml-0 pa-0 ma-0">
                    <label> Cuenta gastos seguridad social: </label>
                </v-card-text>
                <RouteInBagSelectorComponent
                    v-model="stage.social_security_expense_account"
                    :my_bag="my_bag"
                    outlined
                    hide-details="auto"
                    :error="showErrors && !stage.social_security_expense_account"
                    @change="computeStage">
                </RouteInBagSelectorComponent>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card-text class="ml-0 pa-0 ma-0">
                    <label> IRPF: </label>
                </v-card-text>
                <RouteInBagSelectorComponent
                    v-model="stage.irpf"
                    :my_bag="my_bag"
                    outlined
                    hide-details="auto"
                    :error="showErrors && !stage.irpf"
                    @change="computeStage">
                </RouteInBagSelectorComponent>
            </v-col>
            <v-col>
                <v-card-text class="ml-0 pa-0 ma-0">
                    <label> Cuenta IRPF: </label>
                </v-card-text>
                <RouteInBagSelectorComponent
                    v-model="stage.irpf_account"
                    :my_bag="my_bag"
                    outlined
                    hide-details="auto"
                    :error="showErrors && !stage.irpf_account"
                    @change="computeStage">
                </RouteInBagSelectorComponent>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card-text class="ml-0 pa-0 ma-0">
                    <label> Cotizacion SS trabajador por paro: </label>
                </v-card-text>
                <RouteInBagSelectorComponent
                    v-model="stage.cotizacion_paro"
                    :my_bag="my_bag"
                    outlined
                    hide-details="auto"
                    :error="showErrors && !stage.cotizacion_paro"
                    @change="computeStage">
                </RouteInBagSelectorComponent>
            </v-col>
            <v-col>
                <v-card-text class="ml-0 pa-0 ma-0">
                    <label> Cotizacion SS trabajador por formacion: </label>
                </v-card-text>
                <RouteInBagSelectorComponent
                    v-model="stage.cotizacion_formacion"
                    :my_bag="my_bag"
                    outlined
                    hide-details="auto"
                    :error="showErrors && !stage.cotizacion_formacion"
                    @change="computeStage">
                </RouteInBagSelectorComponent>
            </v-col>
            
        </v-row>
        <v-row>
            <v-col >
                <v-card-text class="ml-0 pa-0 ma-0">
                    <label> Cotizacion SS trabajador por contingencias comunes: </label>
                </v-card-text>
                <RouteInBagSelectorComponent
                    v-model="stage.cotizacion_contingencias"
                    :my_bag="my_bag"
                    outlined
                    hide-details="auto"
                    :error="showErrors && !stage.cotizacion_contingencias"
                    @change="computeStage">
                </RouteInBagSelectorComponent>
            </v-col>
            <v-col >
                <v-card-text class="ml-0 pa-0 ma-0">
                    <label> Recuperación líquido: </label>
                </v-card-text>
                <RouteInBagSelectorComponent
                    v-model="stage.recuperacion_liquido"    
                    :my_bag="my_bag"
                    outlined
                    hide-details="auto"
                    :error="showErrors && !stage.recuperacion_liquido"
                    @change="computeStage">
                </RouteInBagSelectorComponent>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="6">
                <v-card-text class="ml-0 pa-0 ma-0">
                    <label> P.P. Extra: </label>
                </v-card-text>
                <RouteInBagSelectorComponent
                    v-model="stage.pp_extra"
                    :my_bag="my_bag"
                    outlined
                    hide-details="auto"
                    :error="showErrors && !stage.pp_extra"
                    @change="computeStage">
                </RouteInBagSelectorComponent>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="6">
                <v-card-text class="ml-0 pa-0 ma-0">
                    <label> Total a pagar: </label>
                </v-card-text>
                <RouteInBagSelectorComponent
                    v-model="stage.total_to_pay"
                    :my_bag="my_bag"
                    outlined
                    hide-details="auto"
                    :error="showErrors && !stage.total_to_pay"
                    @change="computeStage">
                </RouteInBagSelectorComponent>
            </v-col>
        </v-row>
        
    </div>
</template>

<script>
import { PayrollAccounting } from '@/modules/document/domain/WorkflowTemplate';
import { DOCS_FIELD_MAP_SHOW } from "@/modules/document/domain/Document";
import RouteInBagSelectorComponent from '@/modules/document/infra/RouteInBagSelectorComponent';

export default {
    name:'PayrollAccountingDetailComponent',
    components: {
        RouteInBagSelectorComponent
    },
    props:{
        stage: {
            type: PayrollAccounting,
            default: false,
        },
        showErrors: {
            type: Boolean,
            default: false
        },
        my_bag: {
            type: Object,
            default: () => {}
        }
    },
    data(){
        return {
        }
    },
    mounted(){
        console.log(this.stage);
    },
    methods:{
        formatField(field) {
            return DOCS_FIELD_MAP_SHOW[field] || field;
        },
        computeStage(){
            this.$emit('compute-stage');
        }
    },
    computed:{
        
    },
    beforeDestroy() {
        // Remove the stylesheet when the component is destroyed
        // if (this.cssLink && document.head.contains(this.cssLink)) {
        // document.head.removeChild(this.cssLink);
        // }
    }
}
</script>

<style scoped >
/*@import url('https://unpkg.com/json-schema-editor-vue@2.3.0/lib/json-schema-editor-vue.css');*/
.preaty__card {
    border-radius: 5px;
}
.small_scrollbar >>> textarea {
    scrollbar-width: thin;
}
.error--text {
    color: rgba(220, 11, 11, 0.898) !important;
}
</style>